<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <app-invoice-details-toolbar 
            [number]="number"
            [status]="invoice.status"
            [isSubmitting]="isSubmitting" 
            [isLoading]="isLoading" 
            [isExporting]="isExporting"
            (cancelClick)="cancel()" 
            (save)="onSaveClick($event)"
            (exportClick)="exportPdf()"
            [actions]="this.invoice.actions"
            [isReadOnly]="isReadOnly">
        </app-invoice-details-toolbar>
    </div>
    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
        [position]="{ of: 'invoice-details' }">
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll" height="75vh">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 mb-4">
                        <div class="card-header d-flex justify-content-between align-items-center fs-5 fw-medium">
                            <span>Invoice Details</span>
                            <span class="text-muted fs-5">
                                @if (number) {
                                    ID: {{ invoice.numberWithPrefix }}
                                }
                            </span>
                        </div>
                        <div class="card-body">
                            @if (number) {
                                <div class="row mb-3">
                                    <div class="col-6">
                                        <strong class="me-2">Status: </strong>
                                        <span class="badge" [ngClass]="getBadgeClass(invoice.status)">
                                            {{ invoice.status | invoiceStatus}}
                                        </span>
                                    </div>
                                    @if (invoice.purchaseOrderNumber) {
                                        <div class="col-6">
                                            <strong class="me-2">PO: </strong>
                                            <a [routerLink]="`/invoicing/purchase-orders/details/${invoice.purchaseOrderNumber}`"
                                                class="text-decoration-none">{{ invoice.purchaseOrderNumber }}</a>
                                        </div>
                                    }
                                </div>
                            }
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">PO #: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="invoice.purchaseOrderId" [dataSource]="purchaseOrderOptionsDataSource"
                                            displayExpr="number" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly || invoice.purchaseOrderNotFound!"
                                            (onValueChanged)="onPoChanged($event)">
                                        <dx-validator #poValidator> 
                                            <dxi-validation-rule 
                                                type="custom" 
                                                [validationCallback]="validatePurchaseOrder" 
                                                [reevaluate]="true" 
                                                message="Purchase Order is required"/> 
                                        </dx-validator>
                                    </dx-select-box>
                                    <dx-check-box class="mt-2" text="Reference PO not found" 
                                        [(value)]="invoice.purchaseOrderNotFound" 
                                        [readOnly]="isReadOnly"
                                        (onValueChanged)="onPurchaseOrderNotFoundChange($event)">
                                    </dx-check-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Service Type: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="invoice.serviceTypeId" [dataSource]="serviceTypeDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly"
                                            (onValueChanged)="onServiceTypeChanged()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Service Type is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </div>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Bill From: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="invoice.vendorId" [dataSource]="vendorDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly" (onValueChanged)="updateVendorInfo(true)">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Bill From is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                    @if(vendor){
                                        <div class="mt-3">
                                            <ul class="list-unstyled">
                                                <li class="fw-bold">{{ vendor?.name }}</li>
                                                <li>{{ vendor.address }}</li>
                                                <li>{{ vendor.phone ?? '' | formatPhone }}</li>
                                                <li>{{ vendor.email }}</li>
                                                @if (vendor.contact) {
                                                    <li>
                                                        <span class="fw-bold">Contact: </span>
                                                        <a [routerLink]="`/employee/${vendor.contact.id}`" class="text-decoration-none">{{ vendor.contact.name }}</a>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Bill To: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="invoice.billToClientId" [dataSource]="billToDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly" (onValueChanged)="updateBillToInfo()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Bill To is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                    @if (billTo) {
                                        <div class="mt-3">
                                            <ul class="list-unstyled">
                                                <li class="fw-bold">{{ billTo.name }}</li>
                                                <li>{{ billTo.address }}</li>
                                                <li>{{ billTo.city }}, {{ billTo.province }}, {{ billTo.postalCode }}</li>
                                                <li>{{ billTo.phoneNumber ?? '' | formatPhone }}</li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr/>
                            <div class="row g-3 mt-1">
                                <div class="col-md-4">
                                    <label class="form-label">Invoice Number: <span class="text-danger">*</span></label>
                                    <dx-text-box [(value)]="invoice.invoiceNumber" [readOnly]="isReadOnly" [maxLength]="200" stylingMode="filled">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Invoice Number is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Invoice Issue Date: <span class="text-danger">*</span></label>
                                    <dx-date-box [(value)]="invoice.issueDate" [displayFormat]="dateFormat" stylingMode="filled" placeholder="Select Date" 
                                            [readOnly]="isReadOnly" (onValueChanged)="onDateChanged()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Invoice Issue Date is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-date-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Invoice Due Date: <span class="text-danger">*</span></label>
                                    <dx-date-box [(value)]="invoice.dueDate" [displayFormat]="dateFormat" stylingMode="filled" 
                                            placeholder="Select Date" [readOnly]="isReadOnly" [min] = "minDueDate">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Invoice Due Date is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-date-box>
                                </div>
                            </div>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Total Invoice Amount (after tax): <span class="text-danger">*</span></label>
                                    <dx-number-box 
                                        [(value)]="invoice.totalAmountAfterTax" [readOnly]="isReadOnly" [min]="0.01" stylingMode="filled">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Total Invoice Amount is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-number-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Currency: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="invoice.currency" [items]="currencyOptions"
                                        valueExpr="value" displayExpr="text" stylingMode="filled"
                                        placeholder="Select Currency" [readOnly]="isReadOnly"
                                        (onValueChanged)="updateCurrency()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Currency is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </div>
                            <hr/>
                            <app-invoice-details-items [invoice]="invoice" [isReadOnly]="isReadOnly" [permissionType]="PermissionType.InvoiceGlCodes"/>
                            <hr/>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <file-upload label="Upload Original Invoice:*"
                                        [(value)]="newInvoiceFiles" [maxFileSize]="maxFileSize" [maxFileNumber]="3"
                                        [(existingFiles)]="invoice.invoiceFiles"
                                        [(filesToRemove)]="invoiceFilesToRemove"
                                        [isReadOnly]="isReadOnly"
                                        [validators]="invoice.invoiceFiles!.length > 0 ? [] : [{ type: 'required' }]">
                                    </file-upload>
                                </div>
                                <div class="col-md-6">
                                    <file-upload label="Upload Bill of Materials:"
                                        [(value)]="newBillOfMaterialsFiles"
                                        [maxFileSize]="maxFileSize"
                                        [maxFileNumber]="3"
                                        [(existingFiles)]="invoice.billOfMaterialsFiles"
                                        [(filesToRemove)]="billOfMaterialsFilesToRemove"
                                        [isReadOnly]="isReadOnly"
                                        [validators]="[]">
                                    </file-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-notes 
                        [entityId]="number"
                        [noteType]="NoteType.Invoice"
                        [mode]="canViewNotes ? 'normal' : 'invisible'"
                        [canCreate]="canCreateNotes"
                        [canCreateInternal]="canCreateInternalNotes"
                        (noteSaved)="onNoteSaved()"
                        (noteCanceled)="onNoteCanceled()">
                    </app-notes>
                </div>
            }
        </dx-validation-group>
    </dx-scroll-view>
</div>
